<template>
  <div class="options-grid__item" @click="click">
    <span class="options-grid__item__label">
      <slot name="label" />
    </span>

    <slot />
  </div>
</template>

<script>
export default {
  mounted () {
    console.log()
  },

  methods: {
    click () {
      this.$slots.default[0].elm.click()
    }
  }
}
</script>

<style lang="scss" scoped>
  .options-grid__item {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    cursor: pointer;
    user-select: none;

    &__label {
      font-size: 16px;
    }
  }
</style>